export interface HydraMapping {
    readonly '@type': string;
    readonly variable: string;
    readonly property: string;
    readonly required: boolean;
}

export interface HydraSearch {
    readonly '@type': string;
    readonly template: string;
    readonly variableRepresentation: string;
    readonly mapping: HydraMapping[];
}

export interface HydraView {
    readonly '@id': string;
    readonly '@type': string;
    readonly first: string;
    readonly last: string;
    readonly next: string;
}

export interface HydraProperties<T> {
    readonly member: T[];
    readonly totalItems: number;
    readonly '@id'?: string;
    readonly '@type'?: string;
    readonly '@context'?: string;
    readonly view?: HydraView;
    readonly search?: HydraSearch;
}

export const HydraProperties = {
    empty<T>(): HydraProperties<T> {
        return {
            totalItems: 0,
            member: [],
        };
    },
};

export class Hydra<T> implements HydraProperties<T> {
    readonly member: T[];
    readonly search?: HydraSearch;
    readonly totalItems: number;
    readonly view?: HydraView;

    private constructor(data: HydraProperties<T>) {
        this.member = data.member;
        this.search = data.search;
        this.totalItems = data.totalItems;
        this.view = data.view;
    }

    public static from<T>(data: HydraProperties<T>): Hydra<T> {
        return new Hydra<T>(data);
    }

    public static empty<T>(): Hydra<T> {
        return new Hydra<T>(HydraProperties.empty());
    }

    getMember(): T[] {
        return this.member;
    }

    getTotalItems(): number {
        return this.totalItems;
    }

    getSearch(): HydraSearch | undefined {
        return this.search;
    }

    getView(): HydraView | undefined {
        return this.view;
    }

    toJSON(): HydraProperties<T> {
        return {
            member: this.member,
            totalItems: this.totalItems,
            view: this.view,
            search: this.search,
        };
    }
}